import * as React from 'react';
import { FileText, FileSpreadsheet, File } from 'lucide-react';
import { cn, ICON_PX } from '../../../ui';

function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1048576).toFixed(1)} MB`;
}

function getFileIcon(mimeType) {
  if (mimeType?.includes('pdf')) return FileText;
  if (mimeType?.includes('spreadsheet') || mimeType?.includes('excel')) return FileSpreadsheet;
  return File;
}

function AttachmentList({ attachments = [] }) {
  if (attachments.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      {attachments.map((att) => {
        const Icon = getFileIcon(att.mimeType);
        return (
          <div
            key={att.id}
            className={cn(
              'flex items-center gap-1.5 px-2.5 py-1.5 rounded-md',
              'border border-nn-border bg-surface hover:bg-surface-warm transition-colors',
              'cursor-pointer text-body-sm min-w-0'
            )}
          >
            <Icon size={ICON_PX.md} className="text-text-muted shrink-0" />
            <span className="truncate text-text-dark font-medium max-w-[160px]">{att.filename}</span>
            <span className="text-caption text-text-muted shrink-0">{formatSize(att.size)}</span>
          </div>
        );
      })}
    </div>
  );
}

export { AttachmentList };
